import React, {Component} from 'react';
import { connect } from 'react-redux';

import * as actionTypes from "../../store/actions/actionTypes";
import classes from "./PatternExercises.module.css";
import ExercisesList from "../../components/ExercisesList/ExercisesList";
import ExecutionsList from "../../components/ExecutionsList/ExecutionsList";
import ExerciseDetails from "../../components/ExerciseDetails/ExerciseDetails";
import ExecutionDetails from "../../components/ExecutionDetails/ExecutionDetails";

import apiUrl from "../../shared/config";
import history from "../../history";
import {UPDATE_EXERCISES_PAGINATION} from "../../store/actions/actionTypes";
//import axios from "axios";




class PatternExercises extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // Your state variables here.
            // e.g. isLoading: false
            patternExerciseDetails: [],
            patternExecutionDetails: [],
            users: [],
            exercisesCount: 0, // lifted state so it can be used to display in exercises search
        };
    }

    componentDidMount() {
        if (this.props.match.params.exerciseId && ((this.props.selectedExercise.id === null)
            || (this.props.selectedExercise.id !== this.props.match.params.exerciseId))) {
            // If there's exercise id in the URL and either the selected exercise is null or the selected exercise doesn't have
            // doesn't have the same id as the id in the URL, select the exercise with the id in the URL
            this.props.onSelectExercise(this.props.match.params.exerciseId);
            //hack to default execution to always open the example execution as default
            if (!this.props.match.params.executionId && this.props.match.params.exerciseId <= 45) {
                this.props.onSelectExecution(this.props.match.params.exerciseId, this.props.match.params.exerciseId);
            }
            //console.log("In PatternExercises mount. Exercise Id: " + this.props.match.params.exerciseId);
        }

        if (this.props.match.params.executionId && ((this.props.selectedExecution.id === null)
            || (this.props.selectedExecution.id !== this.props.match.params.executionId))) {
            // If there's execution id in the URL and either the selected execution is null or the selected execution
            // doesn't have the same id as the id in the URL, select the execution with the id in the URL
            this.props.onSelectExecution(this.props.match.params.exerciseId, this.props.match.params.executionId);
            //console.log("In PatternExercises mount. Execution Id: " + this.props.match.params.executionId);
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if(this.props.selectedGame.id === null) {
        //     this.props.onSelectGame(this.props.match.params.gameId);
        // }

        // For the exercises in the book, the default executions for each exercise 'happen' to be the same id as
        // their exercises. This is just the way the db is set up... this is dumb. Don't do this... and yet here we are.
        // For other user generated exercises default to no selected execution.
        //@todo This is a mess and should be a case statement that is not nested!
        let defaultExecutionUrlPart = '';
        if (this.props.selectedExercise.id <= 45 ) {
            defaultExecutionUrlPart = '/' + this.props.selectedExercise.id;
        }
        if (
            (Number(prevProps.selectedExercise.id) !== Number(this.props.selectedExercise.id)) ||
            (Number(prevProps.selectedExecution.id) !== Number(this.props.selectedExecution.id))
        ) {
            if (
                (this.props.selectedExercise.id !== undefined && this.props.selectedExercise.id !== null) &&
                (this.props.selectedExecution.id !== undefined && this.props.selectedExecution.id !== null)
            ) {
                // In the case that there's been a change to the selected exercise and the selected exercise is
                // not null or undefined, add the new exercise's link to the browser history
                if (history.location.pathname !== '/PatternLibraryApp/PatternExercises/' +
                    this.props.selectedExercise.id + this.props.selectedExecution.id) {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log('push gr a', '/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id)
                    history.push('/PatternLibraryApp/PatternExercises/' + this.props.selectedExercise.id + '/' + this.props.selectedExecution.id);
                }
            } else if (
                (this.props.selectedExercise.id !== undefined && this.props.selectedExercise.id !== null) &&
                (this.props.selectedExecution.id === undefined || this.props.selectedExecution.id === null)
            )  {
                // This will default any of the exercises from the book to show the default example execution.
                history.push('/PatternLibraryApp/PatternExercises/' + this.props.selectedExercise.id + defaultExecutionUrlPart);
            }
            else {
                // In the case that there's been a change to the selected exercise and the selected exercise is null
                // or undefined, add the default link to the Pattern Exercises to the browser's history
                if (history.location.pathname !== '/PatternLibraryApp/PatternExercises/') {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log('push gr b', '/PatternLibraryApp/GamesReference/')
                    history.push('/PatternLibraryApp/PatternExercises/')
                }
            }
        } else if ((!this.props.match.params.exerciseId && this.props.selectedExercise.id) &&
            (!this.props.match.params.executionId && this.props.selectedExecution.id)
        ) {
            // In the case that there is no change in the selected exercise, but there's a selected exercise and no
            // exercise id in the URL, replace the link in history with one that goes directly to the selected exercise
            // console.log('push gr r', '/PatternLibraryApp/GamesReference/' + this.props.selectedGame.id)
            history.replace('/PatternLibraryApp/PatternExercises/' + this.props.selectedExercise.id + '/' + this.props.selectedExecution.id);
        }
    }


    exerciseSelectedHandler = (id) => {
        this.props.onSelectExercise(id);
    };

    exerciseCloseHandler = () => {
            this.props.onCloseExerciseDetails();
        };

    executionSelectedHandler = (exerciseId, executionId) => {
        this.props.onSelectExecution(exerciseId, executionId);
    };

    patternSelectedHandler = (id) => {
        this.props.onSelectPattern(id);
    };

    executionCloseHandler = () => {
        this.props.onCloseExecutionDetails();
    };

    listReloadedHandler = () => {
        this.props.onListReloaded();
    };

    executionsListReloadedHandler = () => {
        this.props.onExecutionsListReloaded();
    };

    newExerciseOpenHandler = (id) => {
        this.props.onNewExerciseOpen(id);
    };
    newExerciseCloseHandler = () => {
        this.props.onNewExerciseClosed();
    };

    newExecutionOpenHandler = (id) => {
        this.props.onNewExecutionOpen(id);
    };
    newExecutionCloseHandler = () => {
        this.props.onNewExecutionClosed();
    };

    updateExercisesCount = (num) => {
        this.setState({exercisesCount: num})
    }

    updatePageHandler = (new_offset) => {
        this.props.onUpdatePagination(new_offset);
    };

    updateExecutionsCount = (num) => {
        this.setState({executionsCount: num})
    }

    updateExecutionsPageHandler = (new_offset) => {
        this.props.onUpdateExecutionsPagination(new_offset);
    };

    render() {
        // Here goes your JSX code
        return (
            <div>
                <header><h1 className={classes.PageTitle}>Pattern Exercises</h1></header>
                <section className={classes.Exercises}>
                    <ExercisesList
                        exerciseSelected={this.exerciseSelectedHandler}
                        exerciseId={this.props.selectedExercise.id}
                        selectedExerciseId={this.props.selectedExercise.id}
                        urlExerciseId={this.props.match.params.exerciseId}
                        executionSelected={this.executionSelectedHandler}
                        executionId={this.props.selectedExecution.id}
                        urlExecutionId={this.props.match.params.executionId}
                        reloadList={this.props.reloadList}
                        listReloaded={this.listReloadedHandler}
                        reloadExecutionsList={this.props.reloadExecutionsList}
                        executionsListReloaded={this.executionsListReloadedHandler}
                        patternExercises={this.props.patternExercises}
                        //executionsPagination={this.props.executionsPagination}
                        isAuthenticated={this.props.isAuthenticated}
                        userId={this.props.userId}
                        authenticationLevel={this.props.authenticationLevel}
                        token={this.props.token}
                        permissions={this.props.permissions}
                        updateCount={this.updateExercisesCount}
                        updatePage={this.updatePageHandler}
                    />
                    {
                        /* Content goes here */
                        //  'List of All Exercises:' +
                        //  '  -----------------  ' +
                        // JSON.stringify(this.state.patternExercises) +
                        //  '  -----------------  '
                    }
                </section>
                <section id="exercise-details" className={classes.ExerciseDetails}>
                    <ExerciseDetails
                        id={this.props.selectedExercise.id}
                        urlId={this.props.match.params.exerciseId}
                        exerciseDetailsOpen={this.props.exerciseDetailsOpen}
                        closeExerciseDetails={this.exerciseCloseHandler}
                        patternSelected={this.patternSelectedHandler}
                        gameSelected={this.gameSelectedHandler}
                        exerciseSelected={this.exerciseSelectedHandler}
                        selectedExerciseId={this.props.selectedExercise.id}
                        listReloaded={this.listReloadedHandler}
                        //updateKeywordsFilter={this.updateKeywordsFilterHandler}
                        updatePage={this.updatePageHandler}
                        editExercise={this.newExerciseOpenHandler}
                        isAuthenticated={this.props.isAuthenticated}
                        userId={this.props.userId}
                        authenticationLevel={this.props.authenticationLevel}
                        token={this.props.token}
                        permissions={this.props.permissions}
                    />
                </section>
                <header><h3 className={classes.PageTitle}>Exercise Executions</h3></header>

                <section className={classes.Exercises}>
                    <ExecutionsList
                        exerciseSelected={this.exerciseSelectedHandler}
                        exerciseId={this.props.selectedExercise.id}
                        selectedExerciseId={this.props.selectedExercise.id}
                        urlExerciseId={this.props.match.params.exerciseId}
                        executionSelected={this.executionSelectedHandler}
                        executionId={this.props.selectedExecution.id}
                        selectedExecutionId={this.props.selectedExecution.id}
                        urlExecutionId={this.props.match.params.executionId}
                        reloadList={this.props.reloadList}
                        listReloaded={this.listReloadedHandler}
                        reloadExecutionsList={this.props.reloadExecutionsList}
                        executionsListReloaded={this.executionsListReloadedHandler}
                        executionsPagination={this.props.executionsPagination}
                        isAuthenticated={this.props.isAuthenticated}
                        userId={this.props.userId}
                        authenticationLevel={this.props.authenticationLevel}
                        token={this.props.token}
                        permissions={this.props.permissions}
                        updateCount={this.updateExecutionsCount}
                        updatePage={this.updateExecutionsPageHandler}
                    />
                </section>

                <section id="execution-details" className={classes.ExecutionDetails}>
                    <ExecutionDetails
                        exerciseId={this.props.selectedExercise.id}
                        urlEerciseId={this.props.match.params.exerciseId}
                        executionId={this.props.selectedExecution.id}
                        urlExecutionId={this.props.match.params.executionId}
                        executionDetailsOpen={this.props.executionDetailsOpen}
                        closeExecutionDetails={this.executionCloseHandler}
                        patternSelected={this.patternSelectedHandler}
                        gameSelected={this.gameSelectedHandler}
                        exerciseSelected={this.exerciseSelectedHandler}
                        executionSelected={this.executionSelectedHandler}
                        listReloaded={this.listReloadedHandler}
                        //updateKeywordsFilter={this.updateKeywordsFilterHandler}
                        updatePage={this.updatePageHandler}
                        editExecution={this.newExecutionOpenHandler}
                        isAuthenticated={this.props.isAuthenticated}
                        userId={this.props.userId}
                        authenticationLevel={this.props.authenticationLevel}
                        token={this.props.token}
                        permissions={this.props.permissions}
                    />
                    {
                        // '  -----------------  ' +
                        // '  Exercise Response  ' +
                        // '  -----------------  ' +
                        // JSON.stringify(this.state.patternExecutionDetails)
                    }
                </section>
                <section>
                    <div className={classes.dragon}><img src={apiUrl + "Images/Dragon-rotated.png"} width="200px"
                                                         alt="Pattern Dragon"/></div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedExercise: {
            id: state.patternExercises.selectedExercise.id
        },
        selectedExecution: {
            id: state.patternExercises.selectedExecution.id
        },
        patternExercises: {
            offset: state.patternExercises.exerciseList.offset,
            quantity: state.patternExercises.exerciseList.quantity
        },
        exercises: state.patternExercises.exercises,
        execution: state.patternExercises.execution,
        reloadList: state.patternExercises.reloadList,
        reloadExecutionsList: state.patternExercises.reloadExecutionsList,
        executionsPagination: {
            offset: state.patternExercises.executionsList.offset,
            quantity: state.patternExercises.executionsList.quantity
        },
        exerciseDetailsOpen: state.patternExercises.exerciseDetailsOpen,
        executionDetailsOpen: state.patternExercises.executionDetailsOpen,
        isAuthenticated: state.auth.token !== null,
        userId: state.auth.userId,
        authenticationLevel: state.auth.authLevel,
        token: state.auth.token,
        permissions: state.auth.userPermissions
    }
};

const mapDispatchToProps = dispatch => {
    return {
        // onSelectPattern: (selectedPatternId) => dispatch({ type: actionTypes.SELECT_PATTERN, selectedPatternId: selectedPatternId}),
        onSelectExercise: (selectedExerciseId) => dispatch({
            type: actionTypes.SELECT_EXERCISE,
            selectedExerciseId: selectedExerciseId
        }),
        onCloseExerciseDetails: (selectedExerciseId) => dispatch({
            type: actionTypes.CLOSE_EXERCISE_DETAILS,
            selectedExerciseId: selectedExerciseId
        }),
        onNewExerciseOpen: (selectedExerciseId) => dispatch({
            type: actionTypes.NEW_EXERCISE_OPEN,
            selectedExerciseId: selectedExerciseId
        }),
        onNewExerciseClosed: () => dispatch({type: actionTypes.NEW_EXERCISE_CLOSED}),
        onSelectExecution  : (selectedExerciseId, selectedExecutionId) => dispatch({
            type: actionTypes.SELECT_EXECUTION,
            selectedExerciseId: selectedExerciseId,
            selectedExecutionId: selectedExecutionId
        }),
        onCloseExecutionDetails: (selectedExecutionId) => dispatch({
            type: actionTypes.CLOSE_EXECUTION_DETAILS,
            selectedExecutionId: selectedExecutionId
        }),
        onNewExecutionOpen: (selectedExecutionId) => dispatch({
            type: actionTypes.NEW_EXECUTION_OPEN,
            selectedExecutionId: selectedExecutionId
        }),
        onNewExecutionClosed: (selectedExecutionId) => dispatch({type: actionTypes.NEW_EXECUTION_CLOSED}),
        onListReloaded: () => dispatch({ type: actionTypes.LIST_RELOADED}),
        onExecutionsListReloaded: () => dispatch({ type: actionTypes.EXECUTIONS_LIST_RELOADED}),
        onUpdatePagination: (offset) => dispatch({ type: actionTypes.UPDATE_EXERCISES_PAGINATION, offset: offset}),
        onUpdateExecutionsPagination: (offset) => dispatch({ type: actionTypes.UPDATE_EXECUTIONS_PAGINATION, offset: offset})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternExercises);